import {
  IglooCustomPin,
  IglooCustomPinEmailStatus,
  IglooCustomPinStatus,
  RawIglooCustomPinResponse,
} from '@/models'

export const EMPTY_IGLOO_CUSTOM_PIN: IglooCustomPin = {
  activatedAt: null,
  deviceName: '',
  emailStatus: 'none',
  status: 'none',
}

const PIN_STATUSES: IglooCustomPinStatus[] = ['pending', 'active', 'revoked', 'none']
const EMAIL_STATUSES: IglooCustomPinEmailStatus[] = ['sent', 'failed', 'pending', 'none']

const toDate = (value: string | number | null | undefined): Date | null => {
  if (value === null || value === undefined) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export const normalizeIglooCustomPin = (raw: RawIglooCustomPinResponse): IglooCustomPin => {
  const pin = raw?.pin
  if (!pin) return EMPTY_IGLOO_CUSTOM_PIN

  // Note: an unrecognised status falls back to 'none' rather than to a guess. A custom PIN the
  // client cannot classify must not render as a usable credential.
  const status: IglooCustomPinStatus = PIN_STATUSES.includes(pin.status as IglooCustomPinStatus)
    ? (pin.status as IglooCustomPinStatus)
    : 'none'

  if (status === 'none') return EMPTY_IGLOO_CUSTOM_PIN

  const emailStatus: IglooCustomPinEmailStatus = EMAIL_STATUSES.includes(
    pin.emailStatus as IglooCustomPinEmailStatus,
  )
    ? (pin.emailStatus as IglooCustomPinEmailStatus)
    : 'none'

  return { activatedAt: toDate(pin.activatedAt), deviceName: pin.name ?? '', emailStatus, status }
}
